export default __webpack_public_path__ + "static/media/orange.2e6f80e2.ogg";